import { render, staticRenderFns } from "./ListUnis.vue?vue&type=template&id=7c297d54&"
import script from "./ListUnis.vue?vue&type=script&lang=js&"
export * from "./ListUnis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports